import React from "react"
import { useTranslation } from "react-i18next"

import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { Raw } from "~/components/raw"
import { Theme } from "~/components/Theme/Theme"

import styles from "./index.module.css"

export const IndexesAndRaitings: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Theme className={styles.Wrapper} theme="dark">
      <div className="container grid grid--col-12">
        <div className={styles.ColLeft}>
          <Heading as="div" className={styles.Title} like="h1">
            <Raw html={t("sustainable-development.IndexesAndRaitings.Title")} />
          </Heading>

          <Link href="/sustainable-development/indexes-and-ratings" view="arrow">
            <Raw html={t("sustainable-development.IndexesAndRaitings.Link")} />
          </Link>
        </div>

        <div className={styles.ColRight}>
          <Heading like="h3">
            <Raw html={t("sustainable-development.IndexesAndRaitings.Description")} />
          </Heading>
        </div>
      </div>
    </Theme>
  )
}
